import getRecursiveValue from './getRecursiveValue';

const regex = /{{([^({{|}})]*)}}/g;

const stringCompile = (str: string, params: any, id?: string): string => {
    // const arr = [...str.matchAll(regex)];
    const arr = Array.from(str.matchAll(regex));
    let newStr = str;

    arr.forEach((item) => {
        const key = item[1];
        const value = getRecursiveValue(key, params);
        if (value === undefined && process.env.NODE_ENV !== 'production') {
            console.warn(`[intl] Missing interpolation param: ${key} in ${id ?? str}`);
        }
        if (typeof value === 'object') {
            newStr = newStr.replace(`{{${key}}}`, '');
        } else {
            newStr = newStr.replace(`{{${key}}}`, value);
        }
    });

    return newStr;
};

export default stringCompile;
